import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import hasPermission from '../../../Shared/hasPermission';
import FilterBookmarkedPractices from './FilterBookmarkedPractices';
import FilterTextSearch from './FilterTextSearch';
import FilterUserAssignedPractices from './FilterUserAssignedPractices';
import OpenPracticeWizardButton from './OpenPracticeWizardButton';

const FilterButtons = () => {
    const permissions = useSelector(
        (state) => state.auth.permissions,
        shallowEqual
    );
    const can = (permission) => hasPermission(permission, permissions);
    const canAssignUsers = can(`Assignment`);
    const canUsePracticeWizard = can(`PracticeWorkflow`);
    // TODO: the buttons are all similar enough for factory pattern

    return (
        <div
            id="filterButtons"
            className="d-flex text-light justify-content-around flex-wrap">
            <FilterBookmarkedPractices />
            {canAssignUsers && <FilterUserAssignedPractices />}
            <FilterTextSearch />
            {canUsePracticeWizard && <OpenPracticeWizardButton />}
        </div>
    );
};

export default FilterButtons;
